import React, { useRef, useState, useCallback } from 'react';
import clsx from 'clsx';
import styles from './SignatureDropdown.module.scss';
import ToggleButton from '../../ToggleButton/ToggleButton';
import { useOutsideClick } from '../../../utils/constants/hooks';
import { crossIconBlack, signatureIcon } from '../../../assets/hostedassets';
import { SIGNATURE_TOGGLE_LABEL } from '../constants';

interface SignatureDropdownProps {
    attachSignature: boolean;
    onToggle: (value: boolean) => void;
    signatureData: { userFullName: string; userJobRole?: string; pnoName?: string };
}

const SignatureDropdown: React.FC<SignatureDropdownProps> = ({ attachSignature, onToggle, signatureData }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const close = useCallback(() => setIsOpen(false), []);
    useOutsideClick(containerRef, close);

    const roleLine = signatureData.userJobRole
        ? `${signatureData.userJobRole}, ${signatureData.pnoName || ''}`
        : signatureData.pnoName || '';

    return (
        <div className={styles.SignatureDropdown} ref={containerRef}>
            <button
                type="button"
                className={clsx(styles.TriggerIcon, {
                    [styles.TriggerIconActive]: isOpen,
                    [styles.TriggerIconAttached]: attachSignature,
                })}
                onClick={() => setIsOpen((prev) => !prev)}
                aria-label="Email signature"
                aria-expanded={isOpen}
            >
                <img src={signatureIcon} alt="Signature" />
                {attachSignature && (
                    <span
                        className={styles.RemoveBadge}
                        role="button"
                        aria-label="Remove signature"
                        onClick={(e) => {
                            e.stopPropagation();
                            onToggle(false);
                        }}
                    >
                        <img src={crossIconBlack} alt="" aria-hidden />
                    </span>
                )}
            </button>

            {isOpen && (
                <div className={styles.DropdownPanel}>
                    <div className={styles.ToggleRow}>
                        <span className={styles.ToggleLabel}>{SIGNATURE_TOGGLE_LABEL}</span>
                        <ToggleButton checked={attachSignature} onChange={() => onToggle(!attachSignature)} variant="success" />
                    </div>

                    {attachSignature && (
                        <div className={styles.SignaturePreview}>
                            <span className={styles.SignatureText}>
                                <span className={styles.SignatureLine}>Thanks,</span>
                                {signatureData.userFullName && <span className={styles.SignatureLine}>{signatureData.userFullName},</span>}
                                {roleLine && <span className={styles.SignatureLine}>{roleLine}</span>}
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default SignatureDropdown;
